import { trpc } from 'pos-client/utils/trpc.ts';

export const useOrderVehicleDetails = (orderId: string | null | undefined) => {
  const { data: orderVehicleDetails, isFetching: orderVehicleDetailsLoading } =
    trpc.getOrderVehicleDetails.useQuery(
      {
        orderId: orderId ?? '',
      },
      {
        enabled: orderId !== undefined,
        initialData: [],
        select: (data) => {
          return data ?? [];
        },
      }
    );

  return { orderVehicleDetails, orderVehicleDetailsLoading };
};
